import * as React from "react";
import SelectInput from "./SelectInput";
import { TTranslate } from "../../../service/locale/TranslationService";
import YearPicker from "./YearPicker";
import moment from "moment";
import { DateService } from "../../../service/DateService";
import { Date2Utils } from "../../../common/utils/Date2Utils";

export interface State {
  month?: string;
  year?: string;
}

export interface Props {
  translate: TTranslate;
  disabled?: boolean;
  style?: React.CSSProperties;
  onSelect?: (value: string | null) => void;
  value?: string;
}

export interface TMonth {
  key: string;
  value: string;
  name: string;
}

export default class MonthAndYearPicker extends React.Component<Props, State> {
  constructor(props: any) {
    super(props);

    const { value } = props;

    const { month, year } = Date2Utils().parseDate2(value);

    this.state = {
      ...props,
      month,
      year
    };
  }

  componentDidUpdate(prevProps, prevState) {
    const { month, year } = this.state;
    if (prevState.month !== month || prevState.year !== year) {
      const validationResult = this.validateSelections();

      if (validationResult) {
        this.onValidSelect();
      }
    }
  }

  onValidSelect = () => {
    const { month, year } = this.state;
    const { onSelect } = this.props;

    if (onSelect) {
      if (month && month.length !== 0) {
        const value = `${month}${year}`;
        onSelect(value);
      } else {
        onSelect(year || null);
      }
    }
  };

  validateSelections = (): boolean => {
    const { year } = this.state;
    if (year && year.length !== 0) {
      return true;
    }
    return false;
  };

  onChangeYear = (value: moment.Moment | null) => {
    const selectedYear = value ? value.get("year").toString() : undefined;
    this.setState({ year: selectedYear });
  };

  render() {
    const { translate, disabled, style } = this.props;

    const { month, year } = this.state;

    const months: TMonth[] = [
      {
        key: "01",
        value: "01",
        name: translate("months.01")
      },
      {
        key: "02",
        value: "02",
        name: translate("months.02")
      },
      {
        key: "03",
        value: "03",
        name: translate("months.03")
      },
      {
        key: "04",
        value: "04",
        name: translate("months.04")
      },
      {
        key: "05",
        value: "05",
        name: translate("months.05")
      },
      {
        key: "06",
        value: "06",
        name: translate("months.06")
      },
      {
        key: "07",
        value: "07",
        name: translate("months.07")
      },
      {
        key: "08",
        value: "08",
        name: translate("months.08")
      },
      {
        key: "09",
        value: "09",
        name: translate("months.09")
      },
      {
        key: "10",
        value: "10",
        name: translate("months.10")
      },
      {
        key: "11",
        value: "11",
        name: translate("months.11")
      },
      {
        key: "12",
        value: "12",
        name: translate("months.12")
      }
    ];

    return (
      <span style={style}>
        <SelectInput
          value={month}
          selectOptions={months}
          selectOptionKey={"key"}
          selectOptionValue={"name"}
          disabled={disabled || false}
          allowClear={true}
          optionFilterProp={"name"}
          placeholder={translate("month_and_year_picker.select_month")}
          style={{ width: 150, marginRight: "1em" }}
          onChange={(value) => {
            this.setState({ month: value || undefined });
          }}
        />

        <YearPicker
          value={year ? DateService().parseDate(new Date(year)) : undefined}
          placeholder={translate("month_and_year_picker.select_year")}
          disabled={disabled || false}
          onChange={this.onChangeYear}
        />
      </span>
    );
  }
}
